module.exports = __webpack_public_path__ + "img/guias_mobile.ac04daee.svg";